/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1VIcon24Regular = forwardRef('ArrowDim1VIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.25 3.31 7.03 7.53a.75.75 0 0 1-1.06-1.06l4.44-4.44a2.25 2.25 0 0 1 3.181 0l4.44 4.44a.75.75 0 0 1-1.061 1.06l-4.22-4.22v17.38l4.22-4.22a.75.75 0 0 1 1.06 1.06l-4.439 4.44a2.25 2.25 0 0 1-3.182 0l-4.44-4.44a.75.75 0 0 1 1.061-1.06l4.22 4.219V3.311Z" })));
});
